import {request} from "./request";

// 获取全部企业海报类别
export function getAllPosterClassList() {
    return request({
        url: '/hkt/posterclass/get_poster_class_list',
		params: {
		    pagesize: 99,
		    page: 1,
		}
    })
}
// 获取企业海报类别 传参
export function getPosterClassList(pagesize, page) {
    return request({
        url: '/hkt/posterclass/get_poster_class_list',
        params: {
            pagesize,
            page
        }
    })
}
// 添加企业海报类别
export function addPosterClass(name, is_show) {
    return request({
        url: '/hkt/posterclass/add_poster_class',
        params: {
            name,
            is_show
        }
    })
}
// 修改企业海报类别
export function editPosterClass(class_id, name, is_show) {
    return request({
        url: '/hkt/posterclass/edit_poster_class',
        params: {
            class_id,
            name,
            is_show
        }
    })
}
// 修改企业海报类别
export function delPosterClass(class_id) {
    return request({
        url: '/hkt/posterclass/del_poster_class',
        params: {
            class_id,
        }
    })
}
// 上传海报
// export function addPosterRecord(data) {
//     return request({
//         url: '/hkt/posterrecord/add_poster_record',
//         method: 'post',
//         headers: {
//             'Content-Type': 'multipart/form-data'
//         },
//         data: data
//     })
// }


// 海报图库
// 获取海报列表
export function getPosterPublicTempletList(pagesize, page, title, class_id) {
    return request({
        url: '/hkt/posterpublictemplet/get_poster_public_templet_list',
        params: {
            pagesize,
            page,
            title,
            class_id,
        }
    })
}
// 获取海报列表2
export function getPosterPublic2List(params) {
    return request({
        url: '/hkt/posterpublictemplet/get_poster_public_templet_list',
        params,
    })
}
// 获取单个海报
export function getPosterPublicTemplet(poster_id) {
    return request({
        url: '/hkt/posterpublictemplet/get_poster_public_templet',
        params: {
            poster_id
        }
    })
}




// 企业海报
// 上传企业海报
export function new_diy_poste(data) {
    return request({
         url: '/hkt/postertemplet/build_diy_poster_templet',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
}

// 获取海报模板列表
export function getPosterdataList(params) {
    return request({
        url: '/hkt/postertemplet/get_poster_templet_list',
        params,
    })
}

export function getPosterTempletList(pagesize, page, title, class_id) {
    return request({
        url: '/hkt/postertemplet/get_poster_templet_list',
        params: {
            pagesize,
            page,
            title,
            class_id,
        }
    })
}


// 获取单个海报
export function getPosterTemplet(poster_id) {
    return request({
        url: '/hkt/postertemplet/get_poster_templet',
        params: {
            poster_id
        }
    })
}
// 生成海报
// export function buildPosterTemplet(poster_id, share_type, share_id) {
//     return request({
//         url: '/hkt/postertemplet/build_poster_templet',
//         params: {
//             poster_id,
//             share_type,
//             share_id
//         }
//     })
// }




// 我的海报

// 获取海报列表
export function getPosterList(pagesize, page, title, condition, sort_type) {
    return request({
        url: '/hkt/posterrecord/get_poster_record_list',
        params: {
            pagesize,
            page,
            title,
            condition,
            sort_type
        }
    })
}
// 重新生成
export function posterBuild(id, share_type, share_id, build_rule) {
    return request({
        url: '/hkt/posterrecord/poster_record_build',
        params: {
            id,
            share_type,
            share_id,
            build_rule
        }
    })
}
// 重新生成 获取单条数据
export function checkPoster(id) {
    return request({
        url: '/hkt/posterrecord/check_poster_record',
        params: {
            id,
        }
    })
}

// 上传海报
export function addPoster(data) {
    return request({
        url: '/hkt/posterrecord/add_poster_record',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}


// 获取公共文章列表
export function getArticlePublicList(pagesize, page, title) {
    return request({
        url: '/hkt/article/get_article_list',
        params: {
            pagesize,
            page,
			title,
        }
    })
}
// 获取产品列表
export function getGoodsList(pagesize, page, name, class_id, search_time) {
    return request({
        url: '/hkt/goods/get_goods_list',
        params: {
            pagesize,
            page,
            name,
            class_id,
            search_time
        }
    })
}
// 获取名片列表
export function getMemberList(pagesize, page) {
    return request({
        url: '/hkt/member/get_member_list',
        params: {
            pagesize,
            page
        }
    })
}

// 生成海报模板  海报图库
export function buildPosterPublicTemplet(data) {
    return request({
        url: '/hkt/posterpublictemplet/build_poster_public_templet',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 生成海报模板  企业海报
// 参数名	必选	类型	说明
// poster_id	是	int	海报id
// build_rule	否	string	生成规则
// rule_param	否	string	生成参数
// share_type	是	int	内容类型
// share_id	是	int	内容id
// share_words	否	string	分享语 
export function buildPosterPublicTemplet1(data) {
    return request({
        url: '/hkt/postertemplet/build_poster_templet',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 公共海报 模板生成
export function CommonPublicTemplet(data) {
    return request({
        url: '/hkt/posterpublictemplet/build_poster_public_templet',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data,
    })
}

// 获取 模板规则
export function get_templet_rule(templet_type) {
	return request({
		url: '/hkt/posterpublictemplet/get_templet_rule',
	    params: {
	        templet_type,
	    }
	})
}


// 生成海报模板  个人海报
export function buildPosterRecord(data) {
    return request({
        url: '/hkt/posterrecord/build_poster_record',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}


// 添加海报
export function addPosterRecord(data) {
    return request({
        url: '/hkt/posterrecord/add_poster_record',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
// 海报diy
export function diyPoster(data) {
    return request({
        url: '/hkt/posterrecord/diy_poster',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

// 获取个人海报模板
export function getPosterRecord(id) {
    return request({
        url: '/hkt/posterrecord/get_poster_record',
        params: {
            id,
        }
    })
}


// 下载海报
export function posterDownload(image_url) {
    return request({
        url: '/hkt/posterrecord/poster_download',
        responseType: 'arraybuffer',
        params: {
            image_url,
        }
    })
}

// 删除海报
export function delPosterRecord(poster_id, poster_type) {
    return request({
        url: '/hkt/posterrecord/del_poster_record',
        params: {
            poster_id,
            poster_type,
        }
    })
}